

























































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { AuditEventDto } from '@/shared/dtos/agents-admin';

@Component
export default class AuditEventsTab extends Vue {
    @Prop() public auditEvents: AuditEventDto[] = [];
    @Prop() public loading: boolean = false;

    public search: string = '';
    public selectedEventType: string = 'all';
    public selectedSource: string = 'all';

    public get sortedEvents(): AuditEventDto[] {
        return [...this.auditEvents].sort((a, b) => {
            const dateA = a.created_at ? a.created_at.getTime() : 0;
            const dateB = b.created_at ? b.created_at.getTime() : 0;
            return dateB - dateA;
        });
    }

    public get filteredEvents(): AuditEventDto[] {
        const term = (this.search || '').toLowerCase().trim();
        return this.sortedEvents.filter(evt => {
            const byType = this.selectedEventType === 'all' || evt.event_type === this.selectedEventType;
            const bySource = this.selectedSource === 'all' || evt.source === this.selectedSource;
            if (!byType || !bySource) return false;

            if (!term) return true;

            const text = `${evt.agent_id} ${evt.event_type} ${evt.source} ${evt.message} ${evt.event_id}`.toLowerCase();
            return text.indexOf(term) >= 0;
        });
    }

    public get groupedEvents(): { [key: string]: AuditEventDto[] } {
        const grouped: { [key: string]: AuditEventDto[] } = {};
        this.filteredEvents.forEach(evt => {
            const agentId = evt.agent_id || 'Sin agente';
            if (!grouped[agentId]) {
                grouped[agentId] = [];
            }
            grouped[agentId].push(evt);
        });
        return grouped;
    }

    public get groupedAgents(): string[] {
        return Object.keys(this.groupedEvents).sort();
    }

    public get eventTypeOptions(): string[] {
        const set: { [key: string]: boolean } = {};
        this.auditEvents.forEach(evt => {
            if (evt.event_type) set[evt.event_type] = true;
        });
        return Object.keys(set).sort();
    }

    public get sourceOptions(): string[] {
        const set: { [key: string]: boolean } = {};
        this.auditEvents.forEach(evt => {
            if (evt.source) set[evt.source] = true;
        });
        return Object.keys(set).sort();
    }

    public get eventTypeSelectItems(): string[] {
        return ['all', ...this.eventTypeOptions];
    }

    public get sourceSelectItems(): string[] {
        return ['all', ...this.sourceOptions];
    }

    public get heartbeatCount(): number {
        return this.auditEvents.filter(evt => evt.event_type === 'heartbeat_received').length;
    }

    public formatEventType(value: string): string {
        if (!value) return 'Sin tipo';
        return value.replace(/_/g, ' ');
    }

    public getEventColor(eventType: string): string {
        if (eventType === 'heartbeat_received') return 'success';
        if (eventType.indexOf('error') >= 0 || eventType.indexOf('failed') >= 0) return 'error';
        if (eventType.indexOf('warning') >= 0) return 'warning';
        return 'info';
    }

    public getEventClass(eventType: string): string {
        if (eventType === 'heartbeat_received') return 'event-heartbeat';
        if (eventType.indexOf('error') >= 0 || eventType.indexOf('failed') >= 0) return 'event-error';
        if (eventType.indexOf('warning') >= 0) return 'event-warning';
        return 'event-generic';
    }

    public formatDateTime(date: Date | null): string {
        if (!date) return 'N/A';
        return new Intl.DateTimeFormat('es-ES', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }).format(date);
    }

    public shortId(id: string): string {
        if (!id) return '-';
        return id.length > 20 ? `${id.substring(0, 20)}...` : id;
    }

    public prettyDetails(details: string): string {
        if (!details) return '';
        try {
            const parsed = JSON.parse(details);
            return JSON.stringify(parsed, null, 2);
        } catch (e) {
            return details;
        }
    }
}
